module.exports = __webpack_public_path__ + "img/GI.6b7877b9.svg";